<template>
  <div class="sleeping-courses">
    <div v-if="loading" class="loading">
      Loading courses...
    </div>
    <div v-else-if="error" class="error">
      {{ error }}
    </div>
    <div v-else class="courses-grid">
      <div v-for="course in courses" :key="course.id" class="course-card">
        <div class="course-image">
          <img :src="course.cover_photo" :alt="course.main_title" />
        </div>
        <div class="course-info">
          <h3>{{ course.main_title }}</h3>
          <p v-if="course.duration" class="duration">
            Duration: {{ formatDuration(course.duration) }}
          </p>
          <p class="details">{{ course.details }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'SleepingCourses',
  data() {
    return {
      courses: [],
      loading: true,
      error: null
    };
  },
  methods: {
    async fetchCourses() {
      try {
        const config = {
          method: 'get',
          url: 'https://api.kewaar.com/api/admin/sleeping-courses2',
          headers: { 
            'Authorization': 'Bearer 4846|Xz62Lte34IshohbttoDYNoQ8js1nKJYLYphsTIe2a84c2412',
          }
        };

        const response = await axios.request(config);
        this.courses = response.data.data;
      } catch (error) {
        this.error = 'Failed to load sleeping courses. Please try again later.';
        console.error('Error fetching courses:', error);
      } finally {
        this.loading = false;
      }
    },
    formatDuration(duration) {
      if (!duration) return 'N/A';
      // Parse the duration string (format: "1970-01-01T00:37:28.000000Z")
      const time = duration.split('T')[1].split('.')[0];
      const [hours, minutes, seconds] = time.split(':');
      
      let formattedDuration = '';
      if (hours !== '00') formattedDuration += `${parseInt(hours)}h `;
      if (minutes !== '00') formattedDuration += `${parseInt(minutes)}m `;
      if (seconds !== '00') formattedDuration += `${parseInt(seconds)}s`;
      
      return formattedDuration.trim();
    }
  },
  mounted() {
    this.fetchCourses();
  }
};
</script>

<style scoped>
.sleeping-courses {
  padding: 20px;
}

.courses-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 24px;
  margin-top: 20px;
}

.course-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease;
}

.course-card:hover {
  transform: translateY(-4px);
}

.course-image {
  width: 100%;
  height: 200px;
  overflow: hidden;
}

.course-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.course-info {
  padding: 16px;
}

.course-info h3 {
  margin: 0 0 8px 0;
  font-size: 1.2rem;
  color: #333;
}

.duration {
  color: #666;
  font-size: 0.9rem;
  margin: 8px 0;
}

.details {
  color: #555;
  font-size: 0.9rem;
  margin: 8px 0 0 0;
}

.loading, .error {
  text-align: center;
  padding: 40px;
  font-size: 1.1rem;
  color: #666;
}

.error {
  color: #dc3545;
}
</style> 